// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"6e2b5ffd","531":"24a68e24","667":"a4ef87f5","690":"f7bcbada","787":"bd46f37b","820":"675b5a9c","877":"79323778"}[chunkId] + ".chunk.js";
};